import React from 'react'

const Exit = ({ className }: { className?: string }) => {
    return (
        <svg className={className} fill="none" height="26" viewBox="0 0 26 26" width="26" xmlns="http://www.w3.org/2000/svg">
<path d="M6.81829 6.00045H12.5C13.0523 6.00045 13.5 5.55274 13.5 5.00047C13.5 4.44819 13.0523 4.00049 12.5 4.00049H6.81829C5.76831 4.00049 4.90924 4.90047 4.90924 6.00045V20.0002C4.90924 21.1001 5.76831 22.0001 6.81829 22.0001H12.5C13.0523 22.0001 13.5 21.5524 13.5 21.0001C13.5 20.4479 13.0523 20.0002 12.5 20.0002H6.81829V6.00045Z" fill="currentColor"></path>
<path d="M18.4637 12.0004L17.5735 11.0679C17.217 10.6944 17.217 10.1065 17.5735 9.73301C17.9543 9.33408 18.5912 9.33408 18.972 9.73301L20.7727 11.6195C21.5104 12.3923 21.5104 13.6085 20.7727 14.3814L18.972 16.2678C18.5912 16.6667 17.9543 16.6667 17.5735 16.2678C17.217 15.8943 17.217 15.3064 17.5735 14.9329L18.4637 14.0004H11.6365C11.0843 14.0004 10.6366 13.5527 10.6366 13.0004C10.6366 12.4481 11.0843 12.0004 11.6365 12.0004H18.4637Z" fill="currentColor" opacity="0.5"></path>
</svg>
    )
}

export default Exit
